const TRANSITION_DURATION_MS = 250;
const transitionCls = "vyjtjyvq3v";
const formCls = "vyjf14f0wc5";
const searchbarCls = "vyjsorizje";
const contentCls = "vyjc1vhie9u";

export { TRANSITION_DURATION_MS, contentCls, formCls, searchbarCls, transitionCls };
import "./root.quicksearch.style.linaria.module.css";
//# sourceMappingURL=root.quicksearch.style.js.map
